import type { RouteResources } from '@atlassian/react-resource-router';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';
import { legacyPersonalSettingsAccessTokensRoute } from '@jira/router-routes__legacy-personal-settings-access-tokens-routes/src/legacyPersonalSettingsAccessTokensRoute.tsx';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const legacyPersonalSettingsAccessTokensRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(legacyPersonalSettingsAccessTokensRoute, () => ({
		layout: globalLayout,
		entryPoint: () => pageEntryPoint,
	}));
